'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var theme_common_primitives_commonPrimitives = require('../primitives/commonPrimitives.js');
var theme_common_primitives_defaultPrimitives = require('../primitives/defaultPrimitives.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);

// TODO: use only borderWidths primitives in output
function getBorderWidthsTokens(borderWidths) {
  return {
    0: borderWidths['0'],
    small: borderWidths['1'],
    medium: borderWidths['2'],
    large: borderWidths['3'],
    xLarge: borderWidths['5']
  };
}
function getBorderWidths() {
  var borderWidths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : theme_common_primitives_defaultPrimitives.defaultBorderWidthPrimitives;
  return _objectSpread__default["default"](_objectSpread__default["default"]({}, borderWidths), getBorderWidthsTokens(borderWidths));
}
function getBorderRadii() {
  var sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : theme_common_primitives_defaultPrimitives.defaultSizePrimitives;
  return {
    0: sizes['0'],
    2: sizes['2'],
    4: sizes['4'],
    12: sizes['12'],
    none: 'none',
    small: sizes['2'],
    medium: sizes['4'],
    large: sizes['12'],
    full: '10000px'
  };
}
function getBordersTokens(borderWidthsTokens, colorTokens) {
  return {
    '0': 'none',
    mediumPrimary: "".concat(borderWidthsTokens.medium, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-primary']),
    xLargePrimary: "".concat(borderWidthsTokens.xLarge, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-primary']),
    mediumSecondary: "".concat(borderWidthsTokens.medium, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-secondary']),
    xLargeSecondary: "".concat(borderWidthsTokens.xLarge, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-secondary']),
    smallTertiary: "".concat(borderWidthsTokens.small, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-tertiary']),
    mediumTertiary: "".concat(borderWidthsTokens.medium, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-tertiary']),
    xLargeTertiary: "".concat(borderWidthsTokens.xLarge, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-tertiary']),
    mediumBrandPrimary: "".concat(borderWidthsTokens.medium, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-brand-primary']),
    xLargeBrandPrimary: "".concat(borderWidthsTokens.xLarge, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-brand-primary']),
    mediumBrandAlternative: "".concat(borderWidthsTokens.medium, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-brand-alternative']),
    xLargeBrandAlternative: "".concat(borderWidthsTokens.xLarge, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-brand-alternative']),
    /**
     * @deprecated
     */
    grey4200: "".concat(borderWidthsTokens.medium, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-secondary']),
    /**
     * @deprecated
     */
    grey4500: "".concat(borderWidthsTokens.xLarge, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-secondary']),
    /**
     * @deprecated
     */
    grey3100: "".concat(borderWidthsTokens.small, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-tertiary']),
    /**
     * @deprecated
     */
    grey3200: "".concat(borderWidthsTokens.medium, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-tertiary']),
    /**
     * @deprecated
     */
    grey3500: "".concat(borderWidthsTokens.xLarge, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-tertiary']),
    /**
     * @deprecated
     */
    charcoal200: "".concat(borderWidthsTokens.medium, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-primary']),
    /**
     * @deprecated
     */
    charcoal500: "".concat(borderWidthsTokens.xLarge, " ").concat(theme_common_primitives_commonPrimitives.commonBorderStyles.solid, " ").concat(colorTokens['borders-global-primary'])
  };
}
function getAllBorders(_ref) {
  var colorTokens = _ref.colorTokens,
    borderWidthPrimitives = _ref.borderWidthPrimitives,
    _ref$sizes = _ref.sizes,
    sizes = _ref$sizes === void 0 ? theme_common_primitives_defaultPrimitives.defaultSizePrimitives : _ref$sizes;
  var borderWidths = getBorderWidths(borderWidthPrimitives);
  return {
    radii: getBorderRadii(sizes),
    borderWidths: borderWidths,
    borders: getBordersTokens(borderWidths, colorTokens)
  };
}

exports.getAllBorders = getAllBorders;
exports.getBorderRadii = getBorderRadii;
exports.getBorderWidths = getBorderWidths;
exports.getBorderWidthsTokens = getBorderWidthsTokens;
exports.getBordersTokens = getBordersTokens;
//# sourceMappingURL=borders.js.map
